/**
 * Cross-project navigation utility for BXI Dashboard
 * Handles navigation between landing and dashboard projects
 */

/**
 * Navigate to landing project
 * @param {string} path - Path within landing (e.g., '/', '/about', '/blog')
 */
export const navigateToLanding = (path = '/') => {
  const landingUrl = window.LANDING_URL || process.env.REACT_APP_LANDING_URL || 'https://dev.bxiworld.in';
  const fullUrl = `${landingUrl}${path.startsWith('/') ? path : `/${path}`}`;
  window.location.href = fullUrl;
};

/**
 * Navigate to dashboard project (stays in same project)
 * @param {string} path - Path within dashboard (e.g., '/', '/dashboard', '/cart')
 */
export const navigateToDashboard = (path = '/') => {
  const dashboardUrl = window.location.origin;
  const fullUrl = `${dashboardUrl}${path.startsWith('/') ? path : `/${path}`}`;
  window.location.href = fullUrl;
};

/**
 * Get landing URL for a specific path
 * @param {string} path - Path within landing
 * @returns {string}
 */
export const getLandingUrl = (path = '/') => {
  const landingUrl = window.LANDING_URL || process.env.REACT_APP_LANDING_URL || 'https://dev.bxiworld.in';
  return `${landingUrl}${path.startsWith('/') ? path : `/${path}`}`;
};

/**
 * Check if user should be redirected to landing after logout
 * @param {boolean} isLoggedIn - Whether user is logged in
 * @returns {boolean}
 */
export const shouldRedirectToLanding = (isLoggedIn) => {
  return !isLoggedIn;
};
